import { render, staticRenderFns } from "./RegionVacancyPicker.vue?vue&type=template&id=a4b25694&lang=pug&"
import script from "./RegionVacancyPicker.vue?vue&type=script&lang=js&"
export * from "./RegionVacancyPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports